__turbopack_context__.v({
  "app_light_theme": "VerticalSteps-module-scss-module__bakVCa__app_light_theme",
  "item": "VerticalSteps-module-scss-module__bakVCa__item",
  "itemFlex": "VerticalSteps-module-scss-module__bakVCa__itemFlex",
  "list": "VerticalSteps-module-scss-module__bakVCa__list",
  "listRow": "VerticalSteps-module-scss-module__bakVCa__listRow",
  "number": "VerticalSteps-module-scss-module__bakVCa__number",
  "subtitle": "VerticalSteps-module-scss-module__bakVCa__subtitle",
  "title": "VerticalSteps-module-scss-module__bakVCa__title",
  "titleMin": "VerticalSteps-module-scss-module__bakVCa__titleMin",
  "verticalSteps": "VerticalSteps-module-scss-module__bakVCa__verticalSteps",
});
